export default "__VITE_ASSET__hEjWRLwZ__"